export const PRICE = 9.99;
export const ROUND_PRICE = 18.99;
export const CAT_PRICE = 8.99;

export const SOCIAL_PROOF = {
  rating: 4.9,
  count: 127,
  weeklyOrders: 28, // honest number for "Commandé X fois cette semaine"
};

export const MODEL_CONFIG = {
  hueso: { fy: 252, sz: 88 },
  patas: { fy: 232, sz: 78 },
};

export const FONTS = [
  { value: "'Playfair Display', serif", label: "Luxury Elegance" },
  { value: "'Montserrat', sans-serif", label: "Modern Boutique" },
  { value: "'Cormorant Garamond', serif", label: "Classic Roman" },
  { value: "'Cinzel', serif", label: "Royal Heritage" },
  { value: "'Bodoni Moda', serif", label: "High Fashion" },
  { value: "'Urbanist', sans-serif", label: "Minimal Clean" },
  { value: "'Jost', sans-serif", label: "Futuristic Sans" },
  { value: "'Outfit', sans-serif", label: "Minimal Tech" },
  { value: "'Space Grotesk', sans-serif", label: "Industrial Tech" },
  { value: "'Unbounded', sans-serif", label: "Urban Impact" },
  { value: "'Anton', sans-serif", label: "Heavy Power" },
  { value: "'Righteous', sans-serif", label: "Retro Future" },
  { value: "'Bungee', sans-serif", label: "Street Style" },
  { value: "'Abril Fatface', cursive", label: "Editorial Bold" },
  { value: "'Syne', sans-serif", label: "Artistic Bold" },
  { value: "'Fraunces', serif", label: "Vintage Soft" },
  { value: "'Roboto Slab', serif", label: "Modern Slab" },
];

export const COLORS = [
  { name: "oro", hex: "#d8b45a", label: "Gold Stainless" },
  { name: "amarillo", hex: "#ffd84d", label: "Gold" },
  { name: "azul", hex: "#2f6fff", label: "Blue" },
  { name: "negro", hex: "#2a2a2a", label: "Black" },
  { name: "plata", hex: "#c0c0c0", label: "Silver" },
  { name: "rojo", hex: "#ff3b3b", label: "Red" },
  { name: "rosado", hex: "#ff69b4", label: "Pink" },
  { name: "rosado-palido", hex: "#ffb6c1", label: "Blush" },
  { name: "verde", hex: "#2ecc71", label: "Green" },
  { name: "gato_turquesa", hex: "#17d8d2", label: "Turquoise Premium" },
  { name: "gato_rojo", hex: "#d71920", label: "Rouge Luxe" },
  { name: "gato_morado", hex: "#7a34c9", label: "Violet Élégant" },
  { name: "gato_morado_llavero", hex: "#9d3bd7", label: "Violet porte-clés" },
  { name: "gato_naranja", hex: "#f47b20", label: "Orange Énergie" },
  { name: "gato_azul", hex: "#1572ff", label: "Bleu Royal" },
];

// Reviews now include real customer photos (using existing pet photo assets).
const REVIEW_PHOTOS = {
  luna: "/img/hero/luna-medalla.webp",
  kira: "/img/hero/kira-hero.png",
  nala: "/img/lifestyle/nala-autumn.png",
  simba: "/img/product/simba-close.png",
};

export const translations = {
  fr: {
    nav_home: "Accueil", nav_create: "Créer", nav_catalog: "Catalogue", nav_photos: "Photos", nav_reviews: "Avis", nav_faq: "FAQ", nav_cart: "Panier",
    hero_title: "Médailles personnalisées premium pour chiens & chats",
    hero_text: "Gravure laser durable, livraison gratuite Canada & USA, design élégant pour protéger votre animal avec style.",
    hero_cta: "Créer ma médaille", hero_second: "Voir les photos",
    trust_1: "Gravure laser", trust_2: "Livraison gratuite", trust_3: "Fait au Canada", trust_4: "À partir de 9.99$",
    photo_title: "Nos petits clients", photo_text: "Kira, Nala, Simba et Luna portent leurs médailles personnalisées.",
    catalog_title: "Catalogue premium", catalog_text: "Choisissez un modèle et une couleur. Cliquez sur une plaque pour ouvrir le configurateur avec cette sélection.",
    catalog_select: "Personnaliser ma médaille", catalog_bone: "Os", catalog_paw: "Patte", catalog_round: "Ronde acier",
    reviews_title: "Avis clients",
    reviews_total: "avis vérifiés",
    reviews: [
      { name: "Luna", text: "La médaille rouge est superbe et très visible.", photo: REVIEW_PHOTOS.luna, rating: 5, date: "2026-01-08" },
      { name: "Kira", text: "Très belle qualité, médaille élégante et solide.", photo: REVIEW_PHOTOS.kira, rating: 5, date: "2025-12-22" },
      { name: "Nala", text: "Livraison rapide, la gravure est très claire.", photo: REVIEW_PHOTOS.nala, rating: 5, date: "2025-12-15" },
      { name: "Simba", text: "Parfait pour les promenades, très léger.", photo: REVIEW_PHOTOS.simba, rating: 5, date: "2025-12-03" }
    ],
    faq_page_title: "Questions fréquentes",
    view_front: "DEVANT", view_back: "DERRIÈRE",
    product_note: "Chaque médaille est livrée avec un anneau fendu métallique renforcé pour une fixation sûre.",
    instr_title: "Comment Personnaliser",
    instr_items: ["Choisissez le Modèle et la Couleur.", "Sélectionnez una Typographie Studio.", "Écrivez les données (utilisez l'onglet DERRIÈRE).", "Ajoutez au panier et payez via PayPal."],
    model_label: "1. Modèle", model_bone: "Os", model_paw: "Patte", model_round: "Ronde acier", model_cat: "Chats",
    cat_price_label: "8.99$ CAD", material_cat: "Médaille pour chat • 25 mm • Légère et brillante",
    color_label: "2. Couleur", finish_label: "2. Finition", font_label: "3. Typographie Studio",
    icon_label: "Icône décorative",
    icon_free_badge: "INCLUS GRATUIT",
    icon_help: "Ajoutez un petit symbole gravé à côté du nom — gratuit.",
    material_round: "Acier inoxydable premium • 30 mm • Finition or ou argent",
    spec_size: "30 mm", spec_material: "Acier inoxydable", spec_finish_gold: "Or", spec_finish_silver: "Argent",
    round_price_label: "18.99$ CAD", round_shipping_label: "Livraison gratuite incluse",
    front_label: "4. Gravure Devant", back_label: "5. Gravure Derrière",
    phone_ph: "TÉLÉPHONE", addr_ph: "ADRESSE", extra_ph: "INFOS EXTRAS", name_ph: "NOM DE VOTRE ANIMAL",
    char_counter: "caractères",
    add_to_cart: "Ajouter au panier",
    added_to_cart: "Ajouté au panier ✓",
    view_cart: "Voir le panier",
    cart_title: "Mon panier", cart_empty: "Votre panier est vide pour le moment.", cart_empty_cta: "Créer ma médaille",
    cart_subtitle: "articles prêts à expédier", cart_summary: "Résumé de la commande",
    cart_subtotal: "Sous-total", cart_discount: "Remise volume", cart_shipping: "Livraison", cart_free: "Gratuite",
    cart_remove: "Retirer", cart_clear: "Vider le panier", cart_thanks: "Merci! Votre commande a été reçue.",
    qty_label: "Quantité", total_label: "Total", checkout_note: "Paiement sécurisé via PayPal", social_follow: "SUIVEZ-NOUS",
    discount_2: "15% de rabais pour 2 médailles", discount_3: "20% de rabais pour 3 médailles ou plus",
    free_shipping_msg: "LIVRAISON GRATUITE CANADA & USA",
    free_shipping: "Livraison Gratuite", laser_quality: "Gravure Laser", made_canada: "Fait au Canada",
    urgency_weekly: "commandes cette semaine",
    delivery_estimate: "Livraison estimée 5–10 jours",
    sticky_cta: "Ajouter au panier",
    theme_toggle: "Thème",
    faq_title: "FOIRE AUX QUESTIONS",
    faqs: [
      { id: "qualite", q: "LA GRAVURE EST-ELLE DE QUALITÉ ?", a: "Oui. La plaque est gravée avec un laser de haute gamme qui garantit la meilleure qualité et durabilité pour toute la vie de votre animal." },
      { id: "prix", q: "PRIX ET ENVOI ?", a: "Prix de 9,99 $ avec la livraison incluse partout au Canada et USA. Commandez 2 médailles et obtenez 15% de rabais, ou 3+ pour 20% de rabais." },
      { id: "delai", q: "DÉLAI DE LIVRAISON ?", a: "5 à 10 jours ouvrables. Chaque médaille est fabriquée sur commande avec soin." },
      { id: "securite", q: "SÉCURITÉ ?", a: "Totalement sûr. Le tag est fabriqué sans bords dangereux, conçu spécialement pour le confort de votre animal." },
    ],
  },
  en: {
    nav_home: "Home", nav_create: "Create", nav_catalog: "Catalog", nav_photos: "Photos", nav_reviews: "Reviews", nav_faq: "FAQ", nav_cart: "Cart",
    hero_title: "Premium custom pet tags for dogs & cats",
    hero_text: "Durable laser engraving, free Canada & USA shipping, and elegant designs to protect your pet with style.",
    hero_cta: "Create my tag", hero_second: "See photos",
    trust_1: "Laser engraving", trust_2: "Free shipping", trust_3: "Made in Canada", trust_4: "From $9.99",
    photo_title: "Our little customers", photo_text: "Kira, Nala, Simba and Luna wearing their custom tags.",
    catalog_title: "Premium catalog", catalog_text: "Choose a model and color. Click a tag to open the customizer with that selection.",
    catalog_select: "Personalize my tag", catalog_bone: "Bone", catalog_paw: "Paw", catalog_round: "Round steel",
    reviews_title: "Customer reviews",
    reviews_total: "verified reviews",
    reviews: [
      { name: "Luna", text: "The red tag looks beautiful and is very easy to see.", photo: REVIEW_PHOTOS.luna, rating: 5, date: "2026-01-08" },
      { name: "Kira", text: "Very good quality, elegant and strong.", photo: REVIEW_PHOTOS.kira, rating: 5, date: "2025-12-22" },
      { name: "Nala", text: "Fast delivery and the engraving is very clear.", photo: REVIEW_PHOTOS.nala, rating: 5, date: "2025-12-15" },
      { name: "Simba", text: "Perfect for walks, very lightweight.", photo: REVIEW_PHOTOS.simba, rating: 5, date: "2025-12-03" }
    ],
    faq_page_title: "Frequently asked questions",
    view_front: "FRONT", view_back: "BACK",
    product_note: "Each tag comes with a reinforced metal split ring for secure attachment.",
    instr_title: "How to Customize",
    instr_items: ["Choose your Model and Color.", "Select a Studio Typography.", "Write the engraving data (use the BACK tab).", "Add to cart and pay via PayPal."],
    model_label: "1. Model", model_bone: "Bone", model_paw: "Paw", model_round: "Round steel", model_cat: "Cats",
    cat_price_label: "$8.99 CAD", material_cat: "Cat tag • 25 mm • Lightweight and shiny",
    color_label: "2. Color", finish_label: "2. Finish", font_label: "3. Studio Typography",
    icon_label: "Decorative icon", icon_free_badge: "FREE INCLUDED", icon_help: "Add a small engraved symbol next to the name — free.",
    material_round: "Premium stainless steel • 30 mm • Gold or silver finish",
    spec_size: "30 mm", spec_material: "Stainless steel", spec_finish_gold: "Gold", spec_finish_silver: "Silver",
    round_price_label: "$18.99 CAD", round_shipping_label: "Free shipping included",
    front_label: "4. Front Engraving", back_label: "5. Back Engraving",
    phone_ph: "PHONE NUMBER", addr_ph: "ADDRESS", extra_ph: "EXTRA INFO", name_ph: "YOUR PET'S NAME",
    char_counter: "characters",
    add_to_cart: "Add to cart", added_to_cart: "Added ✓", view_cart: "View cart",
    cart_title: "My cart", cart_empty: "Your cart is empty.", cart_empty_cta: "Create my tag",
    cart_subtitle: "items ready to ship", cart_summary: "Order summary",
    cart_subtotal: "Subtotal", cart_discount: "Volume discount", cart_shipping: "Shipping", cart_free: "Free",
    cart_remove: "Remove", cart_clear: "Empty cart", cart_thanks: "Thank you! Your order has been received.",
    qty_label: "Quantity", total_label: "Total", checkout_note: "Secure payment via PayPal", social_follow: "FOLLOW US",
    discount_2: "15% off for 2 tags", discount_3: "20% off for 3 or more",
    free_shipping_msg: "FREE SHIPPING CANADA & USA",
    free_shipping: "Free Shipping", laser_quality: "Laser Engraving", made_canada: "Made in Canada",
    urgency_weekly: "orders this week", delivery_estimate: "Estimated delivery 5–10 days",
    sticky_cta: "Add to cart", theme_toggle: "Theme",
    faq_title: "FREQUENTLY ASKED QUESTIONS",
    faqs: [
      { id: "quality", q: "IS THE ENGRAVING HIGH QUALITY?", a: "Yes. The tag is engraved with a high-end laser that guarantees the best quality and durability for the lifetime of your pet." },
      { id: "price", q: "PRICE AND SHIPPING?", a: "Price of $9.99 with shipping included everywhere in Canada and USA. Order 2 tags and get 15% off, or 3+ for 20% off." },
      { id: "delivery", q: "DELIVERY TIME?", a: "5 to 10 business days. Each tag is handcrafted to order with care." },
      { id: "safety", q: "SAFETY?", a: "Totally safe. The tag is made without dangerous edges, specially designed for your pet's comfort." },
    ],
  },
  es: {
    nav_home: "Inicio", nav_create: "Crear", nav_catalog: "Catálogo", nav_photos: "Fotos", nav_reviews: "Opiniones", nav_faq: "FAQ", nav_cart: "Carrito",
    hero_title: "Placas premium personalizadas para perros y gatos",
    hero_text: "Grabado láser duradero, envío gratis Canadá & USA y diseños elegantes para proteger a tu mascota con estilo.",
    hero_cta: "Crear mi placa", hero_second: "Ver fotos",
    trust_1: "Grabado láser", trust_2: "Envío gratis", trust_3: "Hecho en Canadá", trust_4: "Desde $9.99",
    photo_title: "Nuestros pequeños clientes", photo_text: "Kira, Nala, Simba y Luna usando sus placas personalizadas.",
    catalog_title: "Catálogo premium", catalog_text: "Elige modelo y color. Haz clic en una placa para abrir el configurador con esa selección.",
    catalog_select: "Crear esta placa", catalog_bone: "Hueso", catalog_paw: "Pata", catalog_round: "Redonda acero",
    reviews_title: "Opiniones de clientes",
    reviews_total: "opiniones verificadas",
    reviews: [
      { name: "Luna", text: "La medalla roja es hermosa y se ve muy bien.", photo: REVIEW_PHOTOS.luna, rating: 5, date: "2026-01-08" },
      { name: "Kira", text: "Muy buena calidad, elegante y resistente.", photo: REVIEW_PHOTOS.kira, rating: 5, date: "2025-12-22" },
      { name: "Nala", text: "Entrega rápida y el grabado es muy claro.", photo: REVIEW_PHOTOS.nala, rating: 5, date: "2025-12-15" },
      { name: "Simba", text: "Perfecta para paseos, muy ligera.", photo: REVIEW_PHOTOS.simba, rating: 5, date: "2025-12-03" }
    ],
    faq_page_title: "Preguntas frecuentes",
    view_front: "DELANTE", view_back: "ATRÁS",
    product_note: "Cada medalla se entrega con una argolla metálica reforzada para una sujeción segura.",
    instr_title: "Cómo Personalizar",
    instr_items: ["Elija el Modelo y el Color.", "Seleccione una Tipografía Studio.", "Escriba los datos (use la pestaña ATRÁS).", "Agregue al carrito y pague vía PayPal."],
    model_label: "1. Modelo", model_bone: "Hueso", model_paw: "Pata", model_round: "Redonda acero", model_cat: "Gatos",
    cat_price_label: "$8.99 CAD", material_cat: "Medalla para gato • 25 mm • Liviana y brillante",
    color_label: "2. Color", finish_label: "2. Acabado", font_label: "3. Tipografía Studio",
    icon_label: "Icono decorativo", icon_free_badge: "INCLUIDO GRATIS", icon_help: "Añade un pequeño símbolo grabado junto al nombre — gratis.",
    material_round: "Acero inoxidable premium • 30 mm • Acabado oro o plata",
    spec_size: "30 mm", spec_material: "Acero inoxidable", spec_finish_gold: "Oro", spec_finish_silver: "Plata",
    round_price_label: "$18.99 CAD", round_shipping_label: "Envío gratis incluido",
    front_label: "4. Grabado Delante", back_label: "5. Grabado Atrás",
    phone_ph: "TELÉFONO", addr_ph: "DIRECCIÓN", extra_ph: "INFO EXTRA", name_ph: "NOMBRE DE SU MASCOTA",
    char_counter: "caracteres",
    add_to_cart: "Agregar al carrito", added_to_cart: "Agregado ✓", view_cart: "Ver carrito",
    cart_title: "Mi carrito", cart_empty: "Tu carrito está vacío.", cart_empty_cta: "Crear mi placa",
    cart_subtitle: "artículos listos para enviar", cart_summary: "Resumen del pedido",
    cart_subtotal: "Subtotal", cart_discount: "Descuento por volumen", cart_shipping: "Envío", cart_free: "Gratis",
    cart_remove: "Quitar", cart_clear: "Vaciar carrito", cart_thanks: "¡Gracias! Tu pedido fue recibido.",
    qty_label: "Cantidad", total_label: "Total", checkout_note: "Pago seguro vía PayPal", social_follow: "SÍGUENOS",
    discount_2: "15% descuento x2 medallas", discount_3: "20% descuento x3 o más",
    free_shipping_msg: "ENVÍO GRATUITO CANADÁ Y USA",
    free_shipping: "Envío Gratis", laser_quality: "Grabado Láser", made_canada: "Hecho en Canadá",
    urgency_weekly: "pedidos esta semana", delivery_estimate: "Entrega estimada 5–10 días",
    sticky_cta: "Agregar al carrito", theme_toggle: "Tema",
    faq_title: "PREGUNTAS FRECUENTES",
    faqs: [
      { id: "calidad", q: "¿EL GRABADO ES DE CALIDAD?", a: "Sí. La placa está grabada con láser de alta gama que garantiza la mejor calidad y durabilidad para toda la vida de su mascota." },
      { id: "precio", q: "¿PRECIO Y ENVÍO?", a: "Precio de $9.99 con envío incluido a todo Canadá y USA. Pida 2 medallas y obtenga 15% de descuento, o 3+ para 20% de descuento." },
      { id: "entrega", q: "¿TIEMPO DE ENTREGA?", a: "5 a 10 días hábiles. Cada medalla es fabricada a pedido con cuidado." },
      { id: "seguridad", q: "¿SEGURIDAD?", a: "Totalmente seguro. La placa se fabrica sin bordes peligrosos, diseñada especialmente para la comodidad de su mascota." },
    ],
  },
};
